module.exports = __webpack_public_path__ + "img/sure-gift.3b6ac519.svg";